export function buildBridgeUrl(apiUrl: string, workspaceId: string, authToken: string): string {
  const base = apiUrl.startsWith('https')
    ? apiUrl.replace(/^https/, 'wss')
    : apiUrl.replace(/^http/, 'ws');
  const params = new URLSearchParams({ workspaceId, token: authToken });
  return `${base}/ws/bridge?${params.toString()}`;
}
